module.exports = __webpack_public_path__ + "static/img/a124.ff5098b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a124.jpg
// module id = c0VI
// module chunks = 0